import React from 'react';

const ImpersonationBanner: React.FC = () => {
  const isImpersonating = localStorage.getItem('impersonation') === 'true';
  const isDemoMode = localStorage.getItem('demoMode') === 'true';
  const impersonatedAt = localStorage.getItem('impersonatedAt');
  
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('user') || '{}');
  } catch (e) {}

  if (!isImpersonating || !user) return null;

  const handleReturnToAdmin = () => {
    // Clear all impersonation data (including the main token since this is an impersonation session)
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('impersonation');
    localStorage.removeItem('impersonatedBy');
    localStorage.removeItem('impersonatedAt');
    localStorage.removeItem('demoMode');
    
    // Notify the admin portal that impersonation has ended
    try {
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage({ type: 'IMPERSONATION_ENDED' }, window.location.origin);
        window.opener.focus();
        window.close();
      } else {
        // Fallback: redirect to admin dashboard
        window.location.href = '/admin/dashboard';
      }
    } catch (e) {
      // If messaging fails, just redirect
      window.location.href = '/admin/dashboard';
    }
  };

  const handleCloseSession = () => {
    // Clear impersonation data and close window
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('impersonation');
    localStorage.removeItem('impersonatedBy');
    localStorage.removeItem('impersonatedAt');
    localStorage.removeItem('demoMode');
    
    // Notify admin portal and close window
    try {
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage({ type: 'IMPERSONATION_ENDED' }, window.location.origin);
        window.opener.focus();
        window.close();
      } else {
        // Fallback: redirect to login
        window.location.href = '/login';
      }
    } catch (e) {
      // If messaging fails, just redirect
      window.location.href = '/login';
    }
  };

  const formatTime = (timestamp: string) => {
    try {
      return new Date(timestamp).toLocaleTimeString();
    } catch {
      return '';
    }
  };

  return (
    <div className={`border-b px-4 py-2 flex items-center justify-between z-50 ${
      isDemoMode 
        ? 'bg-purple-100 border-purple-400 text-purple-900' 
        : 'bg-yellow-100 border-yellow-400 text-yellow-900'
    }`}>
      <div className="flex items-center space-x-4">
        <span>
          <strong>{isDemoMode ? '🎯 Demo Mode:' : '🎭 Impersonation Mode:'}</strong> 
          {' '}You are viewing as <span className="font-semibold">{user.name || user.firstName || user.email}</span>
          {user.role === 'DEMO' && ' (Demo Account)'}
        </span>
        {impersonatedAt && (
          <span className="text-sm opacity-75">
            Started at {formatTime(impersonatedAt)}
          </span>
        )}
      </div>
      <div className="flex space-x-2">
        <button
          className={`px-3 py-1 rounded hover:opacity-80 font-medium ${
            isDemoMode 
              ? 'bg-purple-400 text-purple-900 hover:bg-purple-500' 
              : 'bg-yellow-400 text-yellow-900 hover:bg-yellow-500'
          }`}
          onClick={handleCloseSession}
          title="Close this impersonation session"
        >
          Close Session
        </button>
        <button
          className={`px-3 py-1 rounded hover:opacity-80 font-medium ${
            isDemoMode 
              ? 'bg-purple-500 text-white hover:bg-purple-600' 
              : 'bg-yellow-500 text-white hover:bg-yellow-600'
          }`}
          onClick={handleReturnToAdmin}
          title="Return to admin portal"
        >
          Return to Admin
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner; 